module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: "addCommonCost"
  }, [_vm._t("default", [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x"
  })], {
    "slot": "trigger"
  }), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Common cost"), _c('SelectizeCommonCost', {
    on: {
      "optionSelected": _vm.selected
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "row columns",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-570238a1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/AddCommonCostToWallet.vue
// module id = 2361
// module chunks = 1